"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_3g__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "81d4e9cd-9082-40b7-8367-0680c54f3876",
    "data-name": "3g-hi",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "3g-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "a7ce37ad-e445-487a-9da3-15ccef6e9734",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a7aa81c1-6ec9-43d6-9dc0-b4e68425e89a",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "976e8b12-6cab-450c-b222-0cd49f2e6307",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9b6515db-6f64-4155-935c-5ccfce36f954",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "956be8cd-2859-4d93-8fcd-fbf2579b0ff5",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a3d3a937-cb55-4e33-b2b0-4628670e973c",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "894b5a92-36db-4aa9-aa8c-3cfb606873a3",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3d4a25db-4a8d-4fc1-9f04-97efb7195017",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "50f1fb58-8e38-4708-b26e-0721dcc077e5",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7a1a90a8-7ae0-48b0-bb40-42436a911648",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5dad38df-a528-49fd-a895-258f06221ecc",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "81d62c5d-681e-4383-b29c-d10a88c731e9",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6a21ac04-8705-4ae4-95f7-db200ddee4eb",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6f558c11-67f3-4b29-a3ac-f9375e235f43",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cabb76a0-5080-44cd-9583-23c9eaab9f58",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24b1976d-4108-43d8-acfb-84e851ef99ec",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4e6d4541-18a4-48f1-a211-1f8317979b84",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0af9d8e9-2fb7-4bf9-a238-5c560076f8b1",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "161b57ae-b44f-48fc-847e-6670adee822a",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "55835d69-7359-487a-8c47-f9f7adc315c8",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0a0406a6-0021-40d1-b5eb-7c2a542d7eaf",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed75abff-c31c-49b7-b5a6-a1cd052d17c1",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "57caefab-5ae2-4955-8176-14a80b0d42ab",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "197d19a8-9a84-40de-a497-b44d3f50b0c1",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9f046982-3957-4e94-8fdb-3e74de7b534d",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2fc31fc1-e466-4d08-b64d-b2b9c5fdc9b3",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "23075fff-665a-4954-9c49-83d5b190bc3b",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.25a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174.25Z",
    transform: "translate(0 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 191.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.35,127.84a33.35,33.35,0,0,1-12.19-2.06,30.44,30.44,0,0,1-9-5.33l5.38-10.08a30.29,30.29,0,0,0,7.25,4.8,19.51,19.51,0,0,0,8.4,1.82,13.28,13.28,0,0,0,6.34-1.34,8.25,8.25,0,0,0,3.65-3.74,11.83,11.83,0,0,0,1.15-5.18q0-5.76-3.7-8.21t-9.84-2.45a38.79,38.79,0,0,0-5.47.38V88.58a40.31,40.31,0,0,1,3.26-5,67.74,67.74,0,0,1,4.66-5.33q2.93-3.07,4.94-4.8H46.67V62.47h40V73.12A76.17,76.17,0,0,0,80,78.07a59.45,59.45,0,0,0-5.47,5,28.65,28.65,0,0,0-3.31,4.13,20.26,20.26,0,0,1,10.22,2.5,14.51,14.51,0,0,1,6.29,6.86,23.49,23.49,0,0,1,1.92,9.55,22.38,22.38,0,0,1-1.87,9.5,19.86,19.86,0,0,1-5,6.77,20.82,20.82,0,0,1-7.39,4.08A29.62,29.62,0,0,1,66.35,127.84Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.39,127.84a29.21,29.21,0,0,1-11.47-2.21,24.38,24.38,0,0,1-9-6.48,30.14,30.14,0,0,1-5.81-10.42,43.9,43.9,0,0,1-2.06-14A45.12,45.12,0,0,1,99.28,79.8a30.7,30.7,0,0,1,6-10.46,23.69,23.69,0,0,1,8.59-6.19,26.36,26.36,0,0,1,10.22-2q8.26,0,13.54,3.12a21.05,21.05,0,0,1,8,8L137.1,80A15.89,15.89,0,0,0,134,76.15a13.66,13.66,0,0,0-4.51-2.69,15.23,15.23,0,0,0-5.38-1,11.87,11.87,0,0,0-8,3.07,17,17,0,0,0-5.09,8.3,38.47,38.47,0,0,0-1.54,10.9,29.21,29.21,0,0,0,2.59,12.72q2.59,5.42,6.43,7.2a17.74,17.74,0,0,0,7.49,1.78,35.62,35.62,0,0,0,6.19-.43,16.91,16.91,0,0,0,2.74-.62V103.84H125v-11h21.5v30.82a27.76,27.76,0,0,1-7.87,2.88A56.34,56.34,0,0,1,125.39,127.84Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  })))))))))))))))))))))))))))));
}

var _default = ic_3g__dark;
exports.default = _default;